import type { TranslationKey } from '~/composables/translate/translations'

export type StepPath = 'category' | 'lead' | 'coverage' | 'options' | 'personal'

export interface Step {
  path: StepPath
  next?: Step
  translationKey: TranslationKey
}

export const PERSONAL_STEP: Step = {
  path: 'personal',
  translationKey: 'nav_page_confirm',
}

export const OPTIONS_STEP: Step = {
  path: 'options',
  next: PERSONAL_STEP,
  translationKey: 'nav_page_choose_options',
}

export const COVERAGE_STEP: Step = {
  path: 'coverage',
  next: OPTIONS_STEP,
  translationKey: 'nav_page_choose_coverage',
}

export const CATEGORY_STEP: Step = {
  path: 'category',
  next: COVERAGE_STEP,
  translationKey: 'nav_page_choose_category',
}

export const LEAD_STEP: Step = {
  path: 'lead',
  next: COVERAGE_STEP,
  translationKey: 'nav_page_lead',
}

export const STEPS_RECORD: Record<StepPath, Step> = {
  lead: LEAD_STEP,
  category: CATEGORY_STEP,
  coverage: COVERAGE_STEP,
  options: OPTIONS_STEP,
  personal: PERSONAL_STEP,
}
